import React, { useState } from 'react';
import GraphBid from '../../shared/components/GraphBid';
import SelectionBid from '../../shared/components/SelectionBid';
import { Divider } from '@data-products-and-ai/react-components';

export const BidContext = React.createContext({});

const HomePage: React.FC = () => {
  const [selectionBid, setSelectionBid] = useState<object>({});
  return (
    <div className="homePage">
      <div style={{ display: 'block' }}>
        <img
          src="./images/banner-image.png"
          alt="AI-Bid Navigator"
          width={'100%'}
        />
        <SelectionBid setSelectionBid={setSelectionBid} />
      </div>
      <Divider orientation="vertical" />
      <BidContext.Provider value={selectionBid}>
        <GraphBid />
      </BidContext.Provider>
    </div>
  );
};

export default HomePage;
